module.exports = __webpack_public_path__ + "img/knowledge-s-item-bg-2.32082751.png";